import { useState, useEffect, memo } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { v4 as uuidv4 } from 'uuid';
import { useDispatch } from 'react-redux';
import {
  Button,
  FormControl,
  FormLabel,
  ListSubheader,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import client from 'client';
import store from 'app/store';
import { showMessage } from 'app/store/fuse/messageSlice';
import {useTranslation} from 'react-i18next';
import Autocomplete from '@mui/material/Autocomplete';

function ModalSpecialRate({
  isOpenModalSpecial,
  setIsOpenModalSpecial,
  setDataSpecial,
  inputFields,
  setInputFields,
  bill_invoice_rate
}) {
  const dispatch = useDispatch();
  const history = useHistory();
  const methods = useFormContext();
  const [open, setOpen] = useState(isOpenModalSpecial);
  const [contra, setcontra] = useState([]);
  const [ownerOperator, setOwner] = useState([]);
  const [subs, setSubs] = useState([]);
  const [ownerlist, setOwnerlist] = useState([]);
  const [position, setPosition] = useState(0);
  const [subcontractor, setSubcontractor] = useState({});
  const { control, formState, setValue, getValues, reset } = methods;
  const [inputFieldsSpecial, setInputFieldsSpecial] = useState([
    {
      identifi: uuidv4(),
      subcontractor_comp_id: '',
      unit_rate: 0,
      company_id: '',
      hourly_rate: 0,
      date_created: new Date(),
    },
  ]);
  const state = store.getState();
  const user = state?.loadz_auth?.AuthReducer?.user;

  useEffect(() => {
    setOpen(isOpenModalSpecial);
    getAllcontra();
    getAllOwner();
  }, [isOpenModalSpecial]);

  const handleClose = () => {
    setOpen(false);
    setIsOpenModalSpecial(false);
    setInputFieldsSpecial([
      {
        identifi: uuidv4(),
        subcontractor_comp_id: '',
        unit_rate: 0,
        company_id: '',
        hourly_rate: 0,
        date_created: new Date(),
      },
    ]);
  };

  const getAllcontra = async () => {
    const compacctnum = user?.company?.compacctnum;
    try {
      const subs = await client.post(`/props/get-subcon`, { compacctnum });
      const jsonSubs = await subs.data;
      const subcons = jsonSubs.subcon;
      const opt_subs = subcons.map((e) => {
        return {
          compacctnum: e.compacctnum,
          value: e.user_id,
          label: e.compname,
          type: e.relation,
        };
      });
      setSubs(opt_subs);
      setcontra(jsonSubs.subcon);
    } catch (error) {}
  };

  const getAllOwner = async () => {
    const compacctnum = user?.company?.compacctnum;
    try {
      const subs = await client.post(`/ownerop/get`, { comp_acct: compacctnum });
      const jsonSubs = await subs.data;
      const subcons = jsonSubs.ownerops;
      const opt_owner = subcons.map((e) => {
        return { compacctnum: e.compacctnum, value: e.user_id, label: e.compname, type: e.ownerop };
      });
      setOwnerlist(opt_owner);
      setOwner(jsonSubs.ownerops);
    } catch (error) {
      console.log(error);
    }
  };

  const handleChangeInput = (identifi, event) => {
    console.log('bill_invoice_rate',bill_invoice_rate)
    const compacctnum = user?.company?.compacctnum;
    const newInputFields = inputFieldsSpecial.map((i) => {
      if (identifi === i.identifi) {
        i[event.target.name] = event.target.value;
        i.company_id = compacctnum;
      }
      setInputFieldsSpecial([
        ...inputFieldsSpecial,
        {
          identifi: uuidv4(),
          subcontractor_comp_id: '',
          unit_rate: '',
          company_id: compacctnum,
          hourly_rate: 0,
          date_created: new Date(),
        },
      ]);
      setValue('subcontractor', inputFieldsSpecial);
      return i;
    });
    setInputFieldsSpecial(newInputFields);
  };

  const handleCreate = async () => {
    console.log(inputFieldsSpecial);
    if (
      inputFieldsSpecial[0].unit_rate == '' ||
      inputFieldsSpecial[0].subcontractor_comp_id == ''
    ) {
      _showMessage('Please fill in all the fields', 'error');
      return;
    }

    if(inputFieldsSpecial[0].unit_rate < bill_invoice_rate)
    {_showMessage('The rate entered is lower than the Unit Invoice Rate', 'warning');}
    if(inputFieldsSpecial[0].unit_rate > bill_invoice_rate)
    {_showMessage('The rate entered is greater than the Unit Invoice Rate', 'warning');}

    setInputFields([...inputFields, ...inputFieldsSpecial]);
    setDataSpecial(inputFieldsSpecial);
    handleClose();
  };

  const _showMessage = (msg, color) => {
    dispatch(
      showMessage({
        message: msg, //text or html
        autoHideDuration: 6000, //ms
        anchorOrigin: {
          vertical: 'top', //top bottom
          horizontal: 'right', //left center right
        },
        variant: color, //success error info warning null
      })
    );
  };
  const {t} = useTranslation('navigation');

  return (
    <Dialog
      open={open}
      onClose={handleClose}
    >
      <DialogTitle>{t('ADD_NEW_SPECIAL_RATES')}</DialogTitle>
      <DialogContent>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <FormControl
            className="customSelect"
            fullWidth
            style={{ marginRight: '10px' }}
          >
            <FormLabel>{t('OWNER_OPERATOR_SUBCONTRACTOR')}</FormLabel>
            <Controller
              name="subcontractor_comp_id"
              id="subcontractor_comp_id"
              control={control}
              render={({ field }) => (
                <Autocomplete
                  {...field}
                  options={[...contra.map((item) => ({ ...item, group: t('SUBCONTRACTOR') })), ...ownerOperator.map((item) => ({ ...item, group: t('OWNER_OPERATOR') }))]} // Flatten the options array and add a "group" property
                  groupBy={(option) => option.group} // Group options by "Subcontractor" or "Owner Operator"
                  getOptionLabel={(option) => option.compname || ''} // Display the company name
                  renderGroup={(params) => (
                    <li key={params.key}>
                      <ListSubheader sx={{ backgroundColor: '#edca33' }}>{params.group}</ListSubheader> {/* Group name in red */}
                      {params.children}
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={t('OWNER_OPERATOR_SUBCONTRACTOR')}
                      variant="outlined"
                    />
                  )}
                  onChange={(_, value) => {
                    //console.log('value', _);
                    const selectedValue = value ? value.user_id : '';
                    handleChangeInput(
                      inputFieldsSpecial[position] ? inputFieldsSpecial[position].identifi : '',
                      { target: { name: 'subcontractor_comp_id', value: selectedValue } }
                    );
                  }}
                />
              )}
            />
          </FormControl>

          <FormControl
            className="customSelect"
            fullWidth
          >
            <FormLabel>{t('RATE')}</FormLabel>
            <br />
            <TextField
              margin="dense"
              className="customTextField"
              name="unit_rate"
              variant="outlined"
              required
              fullWidth
              value={inputFieldsSpecial[position] ? inputFieldsSpecial[position].unit_rate : 0}
              onChange={(event) =>
                handleChangeInput(
                  inputFieldsSpecial[position] ? inputFieldsSpecial[position].identifi : '',
                  event
                )
              }
              InputProps={{ shrink: true }}
            />
          </FormControl>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>{t('CANCEL')}</Button>
        <Button onClick={handleCreate}>{t('CREATE')}</Button>
      </DialogActions>
    </Dialog>
  );
}

export default memo(ModalSpecialRate);
